<div
  (click)="onCardClick()"
  *ngIf="!hideIt"
  class="course"
  fxFlex="100"
  [@animate]="{ value: '*', params: { y: '100%' } }"
>
  <div class="course-content pointer" fxLayout="column" fxFlex="1 1 auto">
    <div [style.backgroundColor]="card_color" class="header" fxLayout="column">
      <div>
        <span class="badge badge-pill badge-secondary"
          >{{ "Booth No" | translate }} : {{ booth_no }}</span
        >
      </div>
      <div class="title">{{ booth }}</div>
    </div>
    <div class="mid" fxLayout="column">
      <div class="sub-title">{{ area }}</div>
    </div>
    <div
      [ngStyle]="{ 'margin-top': getExtraContainerHtml() != '' ? 'auto' : '' }"
      class="footer pt-4 pb-4"
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <!-- <button mat-button color="primary">{{'Members' | translate}}</button> -->
      <button mat-button color="warn"><mat-icon>history</mat-icon></button>
    </div>
  </div>
</div>

<div
  *ngIf="showPlaceHolder"
  class="placeholder-root"
  fxFlex="100"
  [@animate]="{ value: '*', params: { y: '100%' } }"
>
  <div
    class="course-content placeholder-background"
    fxLayout="column"
    fxFlex="1 1 auto"
  >
    <div class="header" fxLayout="row" fxLayoutAlign="center center"></div>

    <div class="footer" fxLayout="row" fxLayoutAlign="center center"></div>
  </div>
</div>
